module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("I"), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" sat in a very different interrogation room compared to the Gulag predecessor they had me in this morning. This room was larger, cleaner, and more comfortable. There was no evidence of the base theatrics employed earlier. It might have made some people feel good, but the sudden switch made me nervous. If they didn’t feel the need to hammer a confession out of me, they either had the killer (which was good) and needed me as a witness, ")]), _c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("or")]), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" they had enough evidence to convict me if the case went to trial (which was very, very not good). The two video cameras in the room, both trained on my assigned seat, suggested the latter.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The door opened and a new detective came in. At least, I took her to be a detective, though she certainly didn’t look the part. I guessed her to be five-four, with a pleasantly rounded shape that was easy on the eyes. Her straight brown hair provided an attractive frame for a face that appeared too young for such gruesome affairs as frozen men with missing hearts. She dressed like a detective, though: crisp, black pantsuit with a dark blue blouse. Her smile made a good effort at setting my heart aflutter, but my surroundings and recent experiences put a damper on the effect. There was something familiar about her, but I couldn’t put my finger on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Hi, I’m Special Agent Devereaux. I’m with the FBI.” Her voice was soft and uncertain, almost making her statement sound like a question. She offered her hand and I shook it, despite my surprise. Her tone and body language were decidedly feminine, but her handshake and forearm spoke of restrained, solid muscle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I smiled back, hoping it made me look more like Merlin and less like Manson. “Colin Fisher. I’m the wandering vagabond who stumbled onto the body.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She laughed a little. “It can’t be any fun. Dying father, car trouble, and you end up in here. I’m not sure I could smile if I was in your shoes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The longer I looked at her, the more certain I felt we had met before. I had been questioned by the FBI once before, but I think I would have remembered Agent Devereaux. “The freedom of the gypsy lifestyle has its own price tag. The car will get fixed sooner or later. You’ll find the guy who did this. My dad …” I let it trail off.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Not many Harvard-educated gypsies out there.” That made me gulp. I’d left out my educational background in the previous interviews with the locals. “I bet you’ve seen some pretty amazing things in your travels. Are you planning on writing a book about your experiences?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I tried to keep my nerves out of my voice, but I didn’t like the direction this conversation was headed. “No, I’m not much when it comes to travelogues. The joy is in being there, not reading about it. And I dropped out of Harvard, so I’m just a partially educated idiot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I know and I appreciate the honesty.” She nodded, then leaned a little bit closer across the table. “I’m with the FBI’s Behavioral Sciences Investigative Division. It’s my job to know all about people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I tried to think through the ramifications of that title and found it more than my brain could currently handle. My tongue started moving to put order to the chaos. “Behavioral Sciences means you’re a profiler. Profiling means there is more than one body: a serial killer. And, right now, you’re studying me, which means...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She shook her head, letting long auburn strands dance around her head. “Relax, Colin. I’m simply here to talk with you. We get called in for things like this sometimes. I have to talk to everyone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Not okay. This one is dangerous. You’ve got a stupid streak a mile wide for pretty girls.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin, you told the detectives this morning that you drove here from Saint Louis and were on your way to Colorado because your dad was sick. Is that right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Yes, ma’am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“And your last stop before Lake Thunderbird was a travel plaza in Tulsa?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Yes, ma’am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Did you plan to stop at the lake?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No, ma’am. I had to backtrack off of I-44 to I-40 to find a natural gas filling station. I saw a sign on the Interstate for the lake and it sounded like a nice place to take a break. I’m a sucker for nature hikes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She smiled again, her white teeth beaming a hypnotic signal a few shades too bright to be comfortable. Her eyes were a stormy blue and that somehow struck me as wrong. “I understand,” she said. “My grandparents had a duck pond on their farm when I was a little girl. I loved spending time down by the water’s edge.” She paused as if lost in nostalgia, though I suspected her pacing was all part of some greater script. “What did you do while you were at the lake?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I walked around for a bit, let my legs stretch. The weather was nice, so I grabbed a spot under an oak tree and tried to read. It didn’t go too well. I couldn’t concentrate…too busy thinking about my dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I’m guessing you were not eager to get there. Family can be tough.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“She’s fishing, Colin. Don’t trust her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I ignored my inner cynicism. If she wanted to play Dr. Freud with my childhood, I would let her. “Yeah, he’s my dad, but we…we struggled after Mom died. When I dropped out of school, conversation went from strained to impossible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I expected her to plunge ahead through the opening and ask me when my dad started molesting me, or whatever it was that psychologists cared about. She didn’t, instead making an abrupt U-turn. “I saw the books in your car. Which one were you reading? Maybe I could get it in here to you…something to read between interviews.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I really didn’t want to talk about my choice of literature. The only thing more suspicious than a vagabond was a vagabond obsessed with the occult. “Yiddish fairy tales from Germany.” I forced myself to blush, as if I were an English professor caught red-handed with a Harry Potter novel.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Yiddish? Are you Jewish, Colin?” She chuckled. “I’m sorry that came out wrong. I mean…it’s an unusual language outside of certain subpopulations.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No offense taken. Religiously, I’m Catholic. Race-wise, I don’t know…Fisher is British, but my branch of the family is American Heinz 57. I just have a gift for languages.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I’d say. What about this one? What languages are in it?” She slid a large folio-sized book on to the table, wrapped in a plastic evidence collection bag. It was as bad as I’d feared, I realized as I looked at the black leather cover shining under the fluorescent lights. I’d rather talk about my family dynamic than that damned book.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Quite a few, I think. English, Aramaic, Sanskrit, Latin…might be a couple others.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Careful, Colin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Damn it, you think I don’t know that? This isn’t going the way we want it to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She asked another question, oblivious to the internal dialogue I had to drown out to hear her. “You don’t know all the languages in the book?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I shook my head. “A lot of side comments have been added helter-skelter by previous owners. It’s a very old book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“So you can’t read it all?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I bit my lips, not wanting to answer that question directly. Omitting the truth was one thing, but lying to the FBI didn’t seem prudent if I could avoid it. Agent Devereaux of the straight brown hair, Irish white skin, and wrong-colored eyes waited for a moment before asking something else. “So what is it? I’ve never seen anything like it. Our analysts have a betting pool as to how much it’s worth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I tried to put a humble face on it. “I picked it up at an estate sale for fifty bucks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“What do you think ")]), _c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Antiques Roadshow")]), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" would say it was worth?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I shook my head. “I wouldn’t be qualified to say,” I allowed. “More than I paid for it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She looked at it quizzically, as if afraid it might bite her hand if it came too close to its cover. “But what is it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“It’s a hand-written copy of the Necronomicon. Supposedly it was made from Lovecraft’s own notes rather than a printed edition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You don’t want to talk about it, do you? You’ve gone pale.” She patted my wrist gently. “It’s okay. It’s just a book, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Wrong.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Yeah, it’s just a book…but I’m not an idiot. In the heart of the Bible Belt, it’s enough to get convicted for any number of things I didn’t do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Okay.” She pulled it off the table and tucked it away. “We don’t have to talk about it if you don’t want to. What do you want to talk about?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I didn’t do it. I’d like to talk about that. I was just in the wrong place at the wrong time. Why on Earth would I call the cops and stick around if I had anything to do with it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Had you ever met the clerk before?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No. I drove by the place on my way to the lake.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She pulled out a notebook, flipped a few pages, then read four names off. “Do any of those names sound familiar?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I shook my head. “No, but I’ve met a lot of people in my travels.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin, I have to ask this, but have you done any drugs recently?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Drugs? This was a new tack. “No, I mean, I’ve smoked weed before…used peyote, too, once. But that was years ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“She keeps jumping tracks. Maybe it’s an interview trick, but it’s almost schizophrenic. Like she’s two people at once,” my inner voice offered.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“If we took a urine sample right now, would it say any different?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No, I’m clean. You got a cup?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“The deceased…Stephen Bausser…he had a rather large supply of crystal meth in his truck.” She paused. “Are you sure no one asked you to wait around the store and get a package? It’s not like you knew what would be in it, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“She’s soft-selling it, trying to give you a way to confess that doesn’t make us look so bad. It’s their theory: the kill was drug-related and we’re the convenient doped out hippie from out of town.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No, I’ve told you all a dozen times. I just needed a jump for my car.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She started to say something else, but as I looked at her, it all finally clicked into place and I interrupted her. ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("”That’s why they sent you in here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Pardon me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You look like her. Same height, hair color, build. It’s why you spent so much time asking me warm questions you don’t really care about. You’re just getting me to talk to build rapport.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Agent Devereaux’s expression changed, the soft, friendly femininity dissolving into trained steel. “Yes,” she confessed, “You’re far too intelligent for the amateur tactics they’ve been using.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Flattery won’t work, either. I can’t take credit for a crime I didn’t commit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“What about Sarai?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I closed my eyes and let the unspoken accusation slap me. Devereaux’s resemblance to her was uncanny. The eyes should have been a deep forest hazel instead of a lake-water blue, a lone mistake. When I finally spoke again, my voice was quiet, but harsh, full of threat. “I didn’t kill her, Agent Devereaux. I don’t know where she went. She just disappeared.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“One evening she was there, in your apartment, by your own admission. In the morning, she was gone. Nobody’s ever seen her since. Until...” She let it hang.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I took the bait. “Until when?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“We found the body, Mr. Fisher. Her heart was missing, too.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3671ef05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0013.vue
// module id = 99
// module chunks = 0